import { useCallback } from 'react';
import { useDebouncedCallback } from './useDebouncedCallback.js';

const useDelayedRedirect = (navigate, delay) => {
    const redirect = useCallback((path, options) => {
        navigate(path, options);
    }, [navigate]);
    const debouncedRedirect = useDebouncedCallback(redirect, delay);
    // If the delay is 0 or less, return the redirect function directly
    return delay <= 0 ? redirect : debouncedRedirect;
};

export { useDelayedRedirect };
//# sourceMappingURL=useDelayedRedirect.js.map
